import React from 'react';
import { useModal } from '@minecraft.modal';
import { SocialPaywallButton } from './SocialPaywallButton';
import { SocialPaywallConsentModal } from './SocialPaywallConsentModal';

interface SocialPaywallSectionProps {
  eventSourcePage: string;
  setFeatureIsOld?: () => void;
}

export const SocialPaywallSection = ({ eventSourcePage, setFeatureIsOld }: SocialPaywallSectionProps) => {
  const {
    isOpen: isSocialPaywallConsentModalOpen,
    toggleModal: toggleSocialPaywallConsentModal,
    close: closeSocialPaywallConsentModal,
  } = useModal();

  return (
    <>
      <SocialPaywallButton
        eventSourcePage={eventSourcePage}
        setFeatureIsOld={setFeatureIsOld}
        toggleSocialPaywallConsentModal={toggleSocialPaywallConsentModal}
      />
      <SocialPaywallConsentModal
        closeSocialPaywallConsentModal={closeSocialPaywallConsentModal}
        isSocialPaywallConsentModalOpen={isSocialPaywallConsentModalOpen}
      />
    </>
  );
};
